import React, { memo, useEffect, useRef } from 'react'

import { twMerge } from 'tailwind-merge'

export const CHECKBOX_STYLES: string =
  'bg-primary-100 dark:bg-primary-700 w-4 h-4 text-accent-400 border-primary-300 focus:ring-0 focus:ring-offset-0 dark:ring-offset-0 ' +
  'rounded dark:border-primary-600 focus:outline-none dark:focus:outline-none focus:ring-0 dark:focus:ring-0 focus:ring-transparent dark:focus:ring-transparent'

interface Checkbox extends React.HTMLProps<HTMLInputElement> {
  label?: string
  labelClassName?: string
  childrenOnly?: boolean
  indeterminate?: boolean
}

const Checkbox: React.FC<Checkbox> = ({
  className,
  labelClassName,
  childrenOnly = false,
  indeterminate = false,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate
    }
  }, [indeterminate])

  const children = (
    <>
      <input
        ref={inputRef}
        type="checkbox"
        aria-checked={indeterminate ? 'mixed' : undefined}
        className={twMerge(
          props.disabled
            ? 'opacity-50 pointer-events-none'
            : 'cursor-pointer active:scale-95',
          CHECKBOX_STYLES,
          className,
        )}
        {...props}
      />
      {props.label ? (
        <label
          htmlFor={props.id}
          className={twMerge(
            'select-none ml-2 text-sm text-primary-900 dark:text-primary-200',
            labelClassName ?? '',
          )}
        >
          {props.label}
        </label>
      ) : null}
    </>
  )
  if (childrenOnly) {
    return children
  }
  return <div>{children}</div>
}

export default Checkbox
